"use strict";
// adapted from https://github.com/facebook/fbjs/blob/afcf932e06793be334ac2a0afc78fd23ed356765/packages/fbjs/src/performance/performanceNow.js
'use es6';
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _performance = _interopRequireDefault(require("./performance"));

var loadTime = Date.now();
var performanceNow = _performance.default.now ? function () {
  return _performance.default.now();
} : function () {
  return Date.now() - loadTime;
};
var _default = performanceNow;
exports.default = _default;
module.exports = exports.default;